import { useTranslation } from 'react-i18next'
import { Button } from '../../rapid-ui'

export type NewModeSubmitProps = {
	disabled?: boolean
	disabledReason?: string
	validationErrors?: Record<string, string>
	isSubmitting?: boolean
}

export function NewModeSubmit(
	{ disabled = false, disabledReason, validationErrors, isSubmitting }: NewModeSubmitProps,
) {
	const { t } = useTranslation('common')
	const hasValidationErrors = validationErrors && Object.keys(validationErrors).length > 0

	return (
		<div className="mt-6 mb-4 flex flex-col items-center gap-2">
			<Button
				type="green"
				postfix="arrow"
				submit
				disabled={disabled || isSubmitting}
				data-testid="generate-campaign-button"
				data-button-disabled={disabled || isSubmitting}
				data-button-submitting={isSubmitting}
				data-has-validation-errors={hasValidationErrors}
			>
				{isSubmitting ? t('editor.generatingButton') : t('editor.generateButton')}
			</Button>
			{disabled && (
				<div className="text-xs text-grey-500 text-center max-w-xs">
					{disabledReason || t('editor.buttonDisabled')}
					{' · '}
					<span className="text-grey-400">
						{t('editor.stuckHint')}
					</span>
				</div>
			)}
			{!disabled && hasValidationErrors && (
				<div className="text-xs text-red-500 bg-red-50 rounded px-3 py-2 max-w-xs">
					<div className="font-medium mb-1">{t('editor.pleaseFixFollowing')}</div>
					<ul className="list-disc list-inside space-y-0.5">
						{Object.entries(validationErrors!).map(([field, error]) => <li key={field}>{error}</li>)}
					</ul>
				</div>
			)}
		</div>
	)
}
